module.exports = __webpack_public_path__ + "static/media/OpenSans-Light.b270c40a.ttf";